import { useQuery } from '@tanstack/react-query';
import { fetchDateHistory } from '../api';

export function useDateHistory() {
  return useQuery({
    queryKey: ['dateHistory'],
    queryFn: fetchDateHistory,
    refetchInterval: 60_000,
  });
}
